import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly11C2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p1 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/1.webp`;
  const p2 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/2.webp`;
  const p3 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/3.webp`;
  const p4 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/4.webp`;
  const p5 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/5.webp`;
  const p6 = `${config.base_image_url_2026}/home/events-activities/class-assembly/11C/6.webp`;

  const photos = [
    { src: p1, source: p1, rows: 1, cols: 1 },
    { src: p2, source: p2, rows: 1, cols: 1 },
    { src: p3, source: p3, rows: 1, cols: 1 },
    { src: p4, source: p4, rows: 1, cols: 1 },
    { src: p5, source: p5, rows: 1, cols: 1 },
    { src: p6, source: p6, rows: 1, cols: 1 },

  ];

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                <Typography variant="h4" align="center">
       Money Tank 
 </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 11 C   Date: 18 th & 19 th August 2026
                </Typography>

<Typography variant={'subtitle1'} align={'justify'}>
The students of Class 11C presented a two-day assembly programme on Financial Literacy, titled ‘Money
Tank’, with the theme ‘Save More, Spend Wisely and Invest Smartly.’ The programme aimed to educate
students on responsible money management and encourage them to develop sound financial habits from
an early age.
  <br></br>
  The first day featured an engaging and humorous Shark Tank-style business pitching skit depicting
common situations related to pocket money and spending habits. Through relatable scenes, the students
highlighted the importance of distinguishing between needs and wants, spending wisely, saving regularly,
and understanding the value of savings and investments. The skit also encouraged healthier choices by
discouraging unnecessary spending on unhealthy snacks and promoting thoughtful use of money. The
second day featured an interactive quiz on financial literacy, covering the financial system, stock market,
and regulatory authorities. The activity enabled students to test and enhance their knowledge of
important financial concepts in an engaging manner.
  <br></br>
  The two-day programme successfully blended awareness, entertainment and interactive learning,
reinforcing the importance of making informed financial decisions and building responsible money habits
for a secure future.
  <br></br>
 
</Typography>
              </Box>

            <Typography
                variant="h6"
                 color="primary"
                 align="center"
                 fontWeight="normal">
                <br />
“Money Tank – Save More, Spend Wisely and Invest Smartly."
                 <br />
            </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 10E 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>

              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={photos[(currentImage + photos.length - 1) % photos.length].src}
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly11C2026;
